import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Wrapper = styled.div`
  padding-top: ${rem(20)};
`;

export const LogoList = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  gap: ${rem(3.5)};
`;

export const Title = styled.div`
  padding-top: ${rem(16)};
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: ${rem(28)};
  line-height: ${rem(28)};
  font-style: normal;
  font-weight: 600;
  color: ${({ theme }) => theme.color.white};
`;

export const SubTitle = styled.div`
  padding-top: ${rem(8)};
  display: flex;
  justify-content: center;
  align-content: center;
  font-size: ${rem(28)};
  line-height: ${rem(28)};
  font-style: normal;
  font-weight: 600;
  color: ${({ theme }) => theme.color.white};
  gap: ${rem(4)};
`;

export const Image = styled.img`
  
`
